import { ComponentStatuses } from "../../../../src/component-statuses";
import DeprecationBanner from "../../../../components/DeprecationBanner";
import * as React from 'react';
export default {
  ComponentStatuses,
  DeprecationBanner,
  React
};